var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasrehisha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        filter: url(#Path_221);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb109"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_221",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.388
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_154_25",
    "data-name": "Component 154 \\u2013 25",
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    className: "cls-1",
    width: 49,
    height: 63,
    rx: 24.5,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, -4.5, -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221-2",
    "data-name": "Path 221",
    className: "cls-2",
    d: "M31.5,0A31.5,31.5,0,1,1,0,31.5,31.5,31.5,0,0,1,31.5,0Z",
    transform: "translate(4.5 4.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Discount",
    "data-name": "Iconly/Bold/Discount",
    transform: "translate(11.994 11.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discount",
    transform: "translate(2 2.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    className: "cls-1",
    d: "M13.769,1.55a5.283,5.283,0,0,1,7.46-.016h0L22.508,2.81a2.626,2.626,0,0,0,1.856.772h1.8A5.274,5.274,0,0,1,31.439,8.85h0v1.8a2.622,2.622,0,0,0,.771,1.854h0l1.261,1.26a5.3,5.3,0,0,1,.035,7.44h0l-1.3,1.3a2.624,2.624,0,0,0-.771,1.857h0v1.8a5.277,5.277,0,0,1-5.271,5.271h-1.8a2.623,2.623,0,0,0-1.856.769h0l-1.261,1.26A5.243,5.243,0,0,1,17.517,35a5.3,5.3,0,0,1-3.73-1.521h0L12.508,32.2a2.623,2.623,0,0,0-1.856-.769h-1.8a5.277,5.277,0,0,1-5.271-5.271h0v-1.8a2.7,2.7,0,0,0-.771-1.875h0L1.546,21.244a5.29,5.29,0,0,1-.018-7.456h0l1.278-1.28a2.633,2.633,0,0,0,.771-1.873h0V8.85A5.274,5.274,0,0,1,8.848,3.582h1.8a2.626,2.626,0,0,0,1.856-.772h0Zm8.248,18.924A1.532,1.532,0,1,0,23.541,22,1.529,1.529,0,0,0,22.018,20.474Zm1.068-8.561a1.526,1.526,0,0,0-2.154,0h0l-9,9a1.542,1.542,0,0,0,0,2.171,1.5,1.5,0,0,0,2.154,0h0l9-9A1.544,1.544,0,0,0,23.086,11.914Zm-10.07-.438A1.532,1.532,0,1,0,14.54,13,1.539,1.539,0,0,0,13.016,11.476Z",
    transform: "translate(0 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasrehisha);
export default __webpack_public_path__ + "static/media/masrehisha.eff8f52baa773949244d4ec83c19c588.svg";
export { ForwardRef as ReactComponent };